/* eslint-disable react-refresh/only-export-components */
import { createContext, type ReactNode, useContext } from 'react';

import type { AppRuntime } from '../infrastructure/appRuntime';

interface AppRuntimeProviderProps {
  children: ReactNode;
  value: AppRuntime;
}

const AppRuntimeContext = createContext<AppRuntime | null>(null);

export const AppRuntimeProvider = ({ children, value }: AppRuntimeProviderProps) => (
  <AppRuntimeContext.Provider value={value}>{children}</AppRuntimeContext.Provider>
);

export const useAppRuntime = (): AppRuntime => {
  const value = useContext(AppRuntimeContext);
  if (!value) {
    throw new Error('AppRuntime is not initialized. Wrap your app with AppRuntimeProvider.');
  }

  return value;
};
